import React from "react";
import Swal from "sweetalert2";
import { useSinConexion, useVersionNueva } from "../hooks/usePwa";
import { actualizarApp } from "../pwa/registrarServiceWorker";
import style from "../styles/estadoConexion.module.scss";

/* Avisos globales de la PWA: sin conexión y nueva versión disponible. */
const EstadoConexionComponent = () => {
    const sinConexion = useSinConexion();
    const hayVersionNueva = useVersionNueva();

    const confirmarActualizacion = async () => {
        const { isConfirmed } = await Swal.fire({
            title: "¿Actualizar ahora?",
            text: "La aplicación se recargará. Si está en medio de una venta o un registro, termínelo primero.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonText: "Después",
        });
        if (isConfirmed) actualizarApp();
    };

    if (!sinConexion && !hayVersionNueva) return null;

    return (
        <aside className={style.contenedor_avisos} aria-live="polite">
            {sinConexion && (
                <div role="status" className={`${style.aviso} ${style.aviso_sin_conexion}`}>
                    <p>
                        Sin conexión. Se muestran los últimos datos guardados; para registrar
                        o modificar información necesita internet.
                    </p>
                </div>
            )}

            {hayVersionNueva && (
                <div role="status" className={`${style.aviso} ${style.aviso_version}`}>
                    <p>Hay una nueva versión de la aplicación.</p>
                    <button type="button" className={style.boton_aviso} onClick={confirmarActualizacion}>
                        Actualizar
                    </button>
                </div>
            )}
        </aside>
    );
};

export default EstadoConexionComponent;
